export const VALIDATION_CHUNK_SIZE = 6;
export const MAX_PARALLEL_VALIDATIONS = 3;